import * as React from "react";
import { Slot } from "@radix-ui/react-slot";

import { popoverRowClasses } from "@/lib/surface-styles";

export type PopoverRowProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  isSelected?: boolean;
  asChild?: boolean;
};

/** Row inside composer autocomplete popovers (mentions, slash commands, emoji). */
export function PopoverRow({
  isSelected,
  className,
  asChild = false,
  type,
  ...props
}: PopoverRowProps) {
  const Comp = asChild ? Slot : "button";
  return (
    <Comp
      type={asChild ? undefined : (type ?? "button")}
      className={popoverRowClasses(isSelected, className)}
      {...props}
    />
  );
}
